// extracted by mini-css-extract-plugin
export default {"StockLocationAssociation__icon":"StockLocationAssociation_StockLocationAssociation__icon__xM2x6"};